import React from 'react';
import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface DeviceRegistrationActionsProps {
    orgId: number;
    row: any;
    onDelete: () => void;
}

export default function DeviceRegistrationActions({
    orgId,
    row,
    onDelete,
}: DeviceRegistrationActionsProps) {
    const deviceRegistrationId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.delete(
                `${orgId}/device-registration-autoenroll/${deviceRegistrationId}`,
            );

            if (response.status === 204) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete device registration for "${row.original.deviceName}" (${row.original.deviceId})?`,
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };

    return (
        <span className="Table-options">
            <i
                onClick={performDelete}
                className="bi bi-trash3-fill cursor-pointer hover:text-red-600"
                title="Delete device registration"
            ></i>
        </span>
    );
}
